module.exports = __webpack_public_path__ + "static/media/logo.c20a41a6.png";